<template>
  <div class="seasidetms_search">
    <div v-if="loading">
      <Preloader />
    </div>
    <div v-else>
      <ProductsListTiles
        :products="results"
        :cols="`columns-4`"
        v-if="results.length"
      />
      <div class="seasidetms_wrap_pagination col-md-12" v-if="results.length">
        <ul class="page-numbers" v-if="totalPages > 1">
          <li v-if="page > 1">
            <a
              href="#"
              class="prev page-numbers"
              @click.stop.prevent="onPage(page - 1)"
            >
              <span class="seasidetms_theme_icon_slide_prev"></span>
            </a>
          </li>
          <li v-for="(n, i) in pages" :key="`p${i}`">
            <span
              v-if="n == page"
              aria-current="page"
              class="page-numbers current"
            >
              {{ n }}
            </span>
            <span v-else-if="n == null" class="page-numbers dots">…</span>
            <a
              v-else
              href="#"
              class="page-numbers"
              @click.stop.prevent="onPage(n)"
            >
              {{ n }}
            </a>
          </li>
          <li v-if="page < totalPages">
            <a
              href="#"
              class="next page-numbers"
              @click.stop.prevent="onPage(page + 1)"
            >
              <span class="seasidetms_theme_icon_slide_next"></span>
            </a>
          </li>
        </ul>
      </div>
      <div v-else class="emptylist">
        <span>{{ $t('emptyCategory') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Preloader from '@/components/Preloader'
import ProductsListTiles from '@/components/category/ProductsListTiles'

export default {
  name: 'Search',
  components: { Preloader, ProductsListTiles },
  data() {
    return {
      loading: true,
      page: 1,
      perPage: 12,
    }
  },
  computed: {
    results() {
      return Array.isArray(this.search)
        ? this.search.slice(
            (this.page - 1) * this.perPage,
            this.page * this.perPage
          )
        : []
    },
    totalPages() {
      const n = this.search.length
        ? Math.ceil(this.search.length / this.perPage)
        : 0
      return n
    },
    pages() {
      const pages = []
      for (let i = 1; i <= this.totalPages; i++) {
        // no dots required
        if (this.totalPages < 16) {
          pages.push(i)
          continue
        }
        // first portion of pages
        if ((this.page < 8 && i <= this.page + 3) || (this.page > 7 && i < 4)) {
          pages.push(i)
          continue
        }
        // first dots
        if (
          (i === 5 && this.page === 1) ||
          (i === this.page + 4 && this.page > 1 && this.page < 8) ||
          (i === 4 && this.page > 7)
        ) {
          pages.push(null)
          continue
        }
        // middle portion of pages
        if (i > this.page - 3 && i < this.page + 4 && this.page > 5) {
          pages.push(i)
          continue
        }
        // second dots
        if (
          i === this.totalPages - 4 &&
          this.page > 7 &&
          this.page < this.totalPages - 4
        ) {
          pages.push(null)
          continue
        }
        // last portion of pages
        if (i > this.totalPages - 3) {
          pages.push(i)
          continue
        }
      }
      return pages
    },
    ...mapState(['search']),
  },
  methods: {
    imgSrc(item) {
      return Array.isArray(item.img) && item.img.length
        ? `/img${item.img[0]}`
        : item.img
        ? `/img${item.img}`
        : '/img/uploads/error.png'
    },
    description(item) {
      if (item[`exc_${this.$i18n.locale}`]) {
        return item[`exc_${this.$i18n.locale}`]
      } else if (item[`description_${this.$i18n.locale}`]) {
        return item[`description_${this.$i18n.locale}`]
      } else if (item.description) {
        return item.description
      } else {
        return ''
      }
    },
    onPage(n) {
      this.page = n
    },
    ...mapActions(['setHeadline', 'fetchSearch']),
    ...mapMutations(['setBreadcrumbs']),
  },
  beforeMount() {
    // breadcrumbs: Главная » Вы ищите “macbook”
    // title: '115 search results for: macbook'
    const query = getQueryStringValue('q')
    // console.log('*[query]', query)
    const breadcrumbs = [
      {
        name: this.$t('searchTitle', { query }),
      },
    ]
    this.setBreadcrumbs(breadcrumbs)
    if (query) {
      this.fetchSearch(query)
        .then(() => {
          // console.log(this.search)
          this.$h.id('search').value = query
          const title = this.$t('title.search', {
            query,
            total: this.search.length,
          })
          this.setHeadline(title)
          this.loading = false
        })
        .catch(() => {
          console.log('*[error]')
          const title = this.$t('title.search', {
            query,
            total: 0,
          })
          this.setHeadline(title)
          this.loading = false
        })
    }
  },
}
function getQueryStringValue(key) {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        '^(?:.*[&\\?]' +
          encodeURIComponent(key).replace(/[.+*]/g, '\\$&') +
          '(?:\\=([^&]*))?)?.*$',
        'i'
      ),
      '$1'
    )
  )
}
</script>

<style></style>
